<!-- @for (message of messages; track message; let i = $index) { -->
<div [ngClass]="['lib-flash-message py-xs px-sm', !!styleName ? styleName : '']">
  <div [ngClass]="message.button ? 'lib-flash-message__columns' : ''">
    <div>
      <div class=" flex align-items-center mb-xxxs">

        <div class="mr-xxxs flex">
          <lib-info-filled-icon class="flex"></lib-info-filled-icon>
        </div>
        <p class="lib-flash-message__title flex justify-content-start align-items-center font-weight-bold small">
          {{message.title}}
        </p>

      </div>

      <div
        class="lib-flash-message__body small"
        [innerHTML]="message.message"
        (click)="onMessageClick($event)"
      >

      </div>
    </div>
    @if (message.button) {
    <div class="flex justify-content-end">
      <lib-button
        [attr.data-qa-id]="'flash-message-button-' + i"
        styleName="button--primary button--outline button--small button--icon subnav-button"
        [buttonText]="'Refresh'"
        isIconButton="true"
        (clickEvent)="onButtonClick(message)"
      >
        <lib-refresh-icon class="icon-dark-blue"></lib-refresh-icon>
      </lib-button>
    </div>
    }
  </div>
</div>
<!-- } -->
